"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const bignumber_js_1 = require("bignumber.js");
const constants_1 = require("./constants");
bignumber_js_1.default.config({
    EXPONENTIAL_AT: [-9, 20]
});
var BurstValueFormat;
(function (BurstValueFormat) {
    BurstValueFormat[BurstValueFormat["PLANCK"] = 0] = "PLANCK";
    BurstValueFormat[BurstValueFormat["BURST"] = 1] = "BURST";
})(BurstValueFormat = exports.BurstValueFormat || (exports.BurstValueFormat = {}));
function assureValidValue(b) {
    if (!(b && /^-?\d*(\.\d+)?$/.test(b))) {
        throw new Error(`Invalid value: ${b}`);
    }
}
class BurstValue {
    constructor(planck) {
        if (typeof planck === 'string') {
            assureValidValue(planck);
        }
        this._planck = new bignumber_js_1.default(planck);
    }
    static Zero() {
        return new BurstValue('0');
    }
    static fromPlanck(planck) {
        return new BurstValue(planck);
    }
    static fromBurst(burst) {
        const b = new BurstValue('0');
        b.setBurst(typeof burst === 'number' ? burst.toString(10) : burst);
        return b;
    }
    getRaw() {
        return this._planck;
    }
    getPlanck() {
        return this._planck.toString();
    }
    setPlanck(p) {
        assureValidValue(p);
        this._planck = new bignumber_js_1.default(p);
    }
    getBurst() {
        return this._planck.dividedBy(1E8).toString();
    }
    setBurst(b) {
        assureValidValue(b);
        this._planck = new bignumber_js_1.default(b).multipliedBy(1E8);
    }
    equals(burstValue) {
        return this._planck.eq(burstValue._planck);
    }
    lessOrEqual(burstValue) {
        return this._planck.lte(burstValue._planck);
    }
    less(burstValue) {
        return this._planck.lt(burstValue._planck);
    }
    greaterOrEqual(burstValue) {
        return this._planck.gte(burstValue._planck);
    }
    greater(burstValue) {
        return this._planck.gt(burstValue._planck);
    }
    add(burstValue) {
        this._planck = this._planck.plus(burstValue._planck);
        return this;
    }
    subtract(burstValue) {
        this._planck = this._planck.minus(burstValue._planck);
        return this;
    }
    multiply(value) {
        this._planck = this._planck.multipliedBy(value);
        return this;
    }
    divide(value) {
        if (value === 0) {
            throw new Error('Division by zero');
        }
        this._planck = this._planck.div(value);
        return this;
    }
    toString(format = BurstValueFormat.BURST) {
        return format === BurstValueFormat.BURST ? `${constants_1.BurstSymbol} ${this.getBurst()}` : `${constants_1.BurstPlanckSymbol} ${this._planck}`;
    }
    clone() {
        return BurstValue.fromPlanck(this.getPlanck());
    }
}
exports.BurstValue = BurstValue;
//# sourceMappingURL=burstValue.js.map